import stripeLoader from '../../../custom_modules/stripe-loader';

AccountController.$inject = ['$rootScope', '$scope', 'Plans', 'Member',
  'CurrentUser', 'Box', 'Dropbox', 'CurrentCustomer', 'Coupon',
  'CurrentAccount', '$location', '$q', 'PaymentStatusServ', '$uibModal',
  '$window', '$route', '$timeout', '$parse', 'CallingCodes',
  'AuthCodeModalConf', 'PaymentModalConf', 'SubscriptionModalConf',
  'RemovePhoneModalConf', 'RemoveUserModalConf', 'ReferralModalConf',
  'AnalyticsServ', 'Customer', 'AccountSetupModalConf', '$anchorScroll',
  'Clio'
];

export default function AccountController($rootScope, $scope, Plans, Member,
  CurrentUser, Box, Dropbox, CurrentCustomer, Coupon, CurrentAccount, $location,
  $q, PaymentStatusServ, $uibModal, $window, $route, $timeout, $parse,
  CallingCodes, AuthCodeModalConf, PaymentModalConf, SubscriptionModalConf,
  RemovePhoneModalConf, RemoveUserModalConf, ReferralModalConf, AnalyticsServ,
  Customer, AccountSetupModalConf, $anchorScroll, Clio
) {

  stripeLoader({
    writeKey: $window.conf.stripe
  });

  $scope.account = CurrentAccount.data;
  $scope.user = CurrentUser.data;
  CurrentCustomer.subscribe(() => {
    $scope.customer = CurrentCustomer.data;
    $scope.members = CurrentCustomer.data.users;
    // user properties specific to firm (like role)
    $scope.customer.user = CurrentCustomer.data.users.filter(
      user => user.id === $scope.user.id
    )[0];
    $scope.selectedPlan = $parse('customer.plan.name')($scope);
    $scope.selectedPeriod = $parse('customer.plan.period')($scope) ||
      'month';
    $scope.previewPeriod = $scope.selectedPeriod;
    $scope.isTrial = $scope.selectedPlan === 'freeTrial';
    $scope.isCustom = $scope.selectedPlan === 'custom';
  })



  $scope.referrer = {};
  $scope.tab = 'profile';
  Plans.getAll().then((plans) => {
    $scope.plans = plans.data;
  })
  $scope.settingCustomer = false;
  $scope.customerDone = false;
  $scope.countries = CallingCodes;

  var getCountry = function (code) {
    return $scope.countries.filter(function (c) {
      return parseInt(c.code) === parseInt(code);
    })[0] || $scope.countries[0];
  };

  $scope.showMemberEntry = () => {
    $scope.showNewMember = true;
    $scope.initializeNewMember();
    $timeout(() => {
      document.querySelector('[name="userEmail"]')[0].focus();
    });
  }
  $scope.selectRole = (role) => {
    $scope.newMember.data.role = role;
  }
  $scope.initializeNewMember = () => {
    $scope.newMember = new Member({
      role: 'contributor'
    });
  }
  $scope.cancelNewMember = () => {
    $scope.initializeNewMember();
    $scope.showNewMember = false;
  }
  $scope.addMember = () => {
    $scope.newMember.api.add().then(data => {
      $scope.showNewMember = false;
      CurrentCustomer.setProp('users', data);
    }, response => {
      if (response.status === 404) {
        $timeout(() => {
          document.querySelector('[name="newMemberFirstName"]')[0].focus();
        });
      }
    });
  }
  $scope.updateMemberRole = (member, role) => {
    if (member.id === $scope.user.id && !$window.confirm(
        "Are you sure you want to change your role?")) {
      // prevent user self-removal
      return;
    }
    member.role = role;
    $scope.currentMember = new Member(member);
    $scope.currentMember.api.update()
      .then(data => CurrentCustomer.setProp('users', data))
  }

  $scope.selectedCountry = getCountry($scope.user.countryCode);
  var oauthCompleted = $location.search()['oauth-completed']
  if (oauthCompleted) {
    $scope.$emit('updateBrowser');
    $scope.tab = oauthCompleted !== 'cliouser' ? 'firm' : 'profile';
    $location.search('oauth-completed', null);
  } else if ($location.search()['tab']) {
    $scope.tab = $location.search()['tab'];
  }

  if ($scope.user.referredBy) {
    // lookup referrer info and set data
    CurrentUser.api.queryInviter($scope.user.referredBy).then(referrer => {
      $scope.referrer = referrer;
    });
  }

  // scratch area for change password functionality
  $scope.change = {};

  $scope.scrollTo = $anchorScroll;
  $scope.showCouponEntry = function () {
    $scope.coupon.code = '';
    $scope.couponEntryVisible = true;
  };
  $scope.hideCouponEntry = function () {
    $scope.couponEntryVisible = false;
  };
  $scope.showCouponValidation = function (res) {
    var msg = $parse('data.data.code.error')(res) || $parse('status')(res);
    $scope.validatingCoupon = false;
    $scope.couponValidation = msg;
    if ($parse('status')(res)) {
      analytics.track('Coupon Validated', {
        'Coupon': $parse('coupon.code')($scope),
      });
    }
  };
  $scope.hideCouponValidation = function () {
    $scope.couponValidation = null;
  };
  $scope.validateCoupon = function () {
    if ($scope.validatingCoupon) {
      return;
    }
    $scope.validatingCoupon = true;
    Coupon.validate({
        code: $scope.coupon.code
      },
      $scope.showCouponValidation, $scope.showCouponValidation
    );
  };

  $scope.changePassword = function () {
    CurrentUser.api.changePassword(null, $scope.change).then(function () {
        $scope.change = {};
        $scope.passwordValidations = {};
        $scope.passwordValidations.success = 'Your password was updated.';
        $scope.editPassword = 0;
      },
      function (response) {

        $scope.passwordValidations = response.data;
        $scope.change = {};
      }
    );
  };

  $scope.accountSetupModal = function () {
    var conf = AccountSetupModalConf;
    conf.windowTemplateUrl = '/modals/default/modal-container.html';

    $uibModal.open(conf).result.then(() => {
      $scope.account = CurrentAccount.data;
    });
  };

  if (!$scope.account.displayName) {
    $scope.accountSetupModal();
  }

  $scope.resetSelection = function () {
    // object submitted to Stripe (via getStripeToken)
    $scope.newCard = {
      name: '',
      number: '',
      cvc: '',
      exp_month: '',
      exp_year: '',
    };
    $scope.coupon = {
      code: ''
    };

    $scope.phone = {
      country: getCountry($scope.user.countryCode),
      phoneNumber: $scope.user.phoneNumber,
      phoneInput: '',
      busy: false,
      edit: false,
      error: null
    };
  };

  $scope.resetSelection();

  var getStripeToken = function (card) {
    // takes a newCard object, returns a promise for Stripe's response

    var s = $q.defer();

    Stripe.card.createToken(card, function (status, response) {
      $timeout(function () {
        if (response.error) {
          // reject: {message: '', param: '(key in newCard)'}
          s.reject(response);
        } else {
          // resolve: {id: ''}
          s.resolve(response);
        }
      });
    });

    return s.promise;
  };

  $scope.setPaymentError = function (res) {
    // ui expects res.error = {message: '', param: '(key in newCard)'}
    $scope.settingCustomer = false;
    $scope.paymentValidations = res.error;
  };

  $scope.setSubscriptionError = function (res) {
    // ui expects res.error = {message: '', param: '(key in newCard)'}
    $scope.settingCustomer = false;
    $scope.subscriptionValidations = res.error;
  };

  $scope.setSubscriptionSuccess = function (data) {
    $scope.fromTrial = $scope.isTrial;
    CurrentCustomer.setData(data);
    $scope.settingCustomer = false;
    $scope.customerDone = true;
    $scope.resetSelection();
    if (!$scope.fromTrial) {
      $scope.modal.close();
    }
  };

  $scope.selectPlan = function (plan) {
    $scope.selectedPlan = plan;
    // without payment (inferred from freeTrial),
    // confirm plan and enter payment
    // with payment, confirm plan
    if ($scope.isTrial) {
      $scope.setupPaymentModal();
    } else {
      $scope.setSubscriptionModal();
    }
  };

  $scope.selectPeriod = function (period) {
    $scope.selectedPeriod = period;
    $scope.previewPeriod = period;
    if (!$scope.isTrial) {
      $scope.setSubscriptionModal();
    }
  };
  $scope.selectPreviewPeriod = function (period) {
    $scope.previewPeriod = period;
  };
  $scope.setCustomer = function (card) {
    if ($scope.settingCustomer === true) {
      return;
    }
    $scope.settingCustomer = true;
    // setCustomer will attempt to tokenize card with Stripe when called
    // with a card, otherwise it will just set plan and period
    var method = $scope.isTrial ? 'create' : 'update';
    var submit = {
      email: $scope.user.email,
      plan: {
        name: $scope.selectedPlan,
        period: $scope.previewPeriod
      },
      payment: {}

    };
    var setCustomer = function (token) {
      if (token) {
        submit.payment.stripeToken = token.id;
      }
      if ($scope.coupon.code) {
        submit.payment.couponCode = $scope.coupon.code;
      }
      var customer = new Customer(submit);
      customer.api[method]().then(
        $scope.setSubscriptionSuccess, $scope.setSubscriptionError);
    };

    if (card) {
      // Stripe tokenizes card, then
      // calls Customer.create/update with Stripe tokenized card
      getStripeToken(card).then(setCustomer, $scope.setPaymentError);
    } else {
      setCustomer();
    }

  };

  $scope.setupPaymentModal = function () {
    $scope.customerDone = false;
    $scope.modal = $uibModal.open(angular.extend(PaymentModalConf, {
      scope: $scope
    }));
    $scope.modal.result.then($scope.resetSelection, $scope.resetSelection);
  };

  $scope.setSubscriptionModal = function () {
    $scope.customerDone = false;
    $scope.modal = $uibModal.open(angular.extend(SubscriptionModalConf, {
      scope: $scope
    }));
    $scope.modal.result.then($scope.resetSelection, $scope.resetSelection);
  };

  $scope.setPhoneNumber = function () {
    // formats input[tel] for submission
    $scope.phone.phoneNumber = $scope.phone.phoneInput.replace(/\D/g, '');
  };

  $scope.editPhone = function () {
    $scope.phone.edit = true;
    $timeout(function () {
      document.querySelector('[name="phoneNumber"]').focus();
    });
  };

  $scope.addPhone = function () {
    if ($scope.phone.busy) return;
    $scope.phone.busy = true;
    CurrentUser.api.addPhone({}, {
      countryCode: $parse('phone.country.code')($scope),
      phoneNumber: $parse('phone.phoneNumber')($scope)
    }).then(function () {
      $scope.phone.error = null;
      $scope.authCodeModal();
    }, function (response) {
      $scope.phone.busy = false;
      $scope.phone.error = response.data;
    });

  };

  $scope.authCodeModal = function () {
    $uibModal.open(
      angular.extend(AuthCodeModalConf, {
        resolve: {
          phone: function () {
            return $scope.phone;
          }
        }
      })).result.then(function (data) {
      $scope.user = data;
      $scope.resetSelection();
    }, $scope.resetSelection);
  };

  $scope.removePhoneModal = function () {
    $uibModal.open(RemovePhoneModalConf).result.then(function (data) {
      $scope.user = data;
      $scope.resetSelection();
    }, $scope.resetSelection);
  };


  $scope.removeUserModal = function (member) {
    $scope.selectedMember = member;
    $uibModal.open(angular.extend(RemoveUserModalConf, {
      resolve: {
        selectedMember: () => member
      }
    })).result.then(
      () => $scope.selectedMember = {},
      () => $scope.selectedMember = {}
    );
  };

  $scope.referralModal = function (origin) {
    $scope.modal = $uibModal.open(angular.extend(ReferralModalConf, {
      windowTemplateUrl: '/modals/default/modal-container.html'
    }));
    analytics.track('Referral Modal Opened', {
      Origin: origin || 'Account Page'
    });
  };

  $scope.openBoxAuth = function (e) {
    e.stopPropagation();
    e.preventDefault();
    var boxId = window.conf.box;

    $window.open(
      "https://account.box.com/api/oauth2/authorize?response_type=code&client_id=" +
      boxId + "&box_login=" + $scope.user.email + "&state=" + $scope.user.currentAccountId,
      '_blank',
      'height=700,width=525,status=no,scrollbars=no, resizable=yes');
  };
  $scope.disconnectBox = function (e) {
    e.stopPropagation();
    e.preventDefault();
    Box.disconnect({}, function () {
      $scope.$emit('updateBrowser');
      $location.url('/account?oauth-completed=box');
      document.location.reload();
    }, function (response) {});
  };

  $scope.openDropboxAuth = function (e) {
    e.stopPropagation();
    e.preventDefault();
    var dropboxId = window.conf.dropbox;
    var redirectUri = window.conf.dropboxUri;
    $window.open(
      "https://www.dropbox.com/1/oauth2/authorize?response_type=code&state=" +
      $scope.user.currentAccountId + "&client_id=" + dropboxId +
      "&redirect_uri=" + redirectUri, '_blank',
      'height=700,width=525,status=no,scrollbars=no, resizable=yes');
  };
  $scope.disconnectDropbox = function (e) {
    e.stopPropagation();
    e.preventDefault();
    Dropbox.disconnect({}, function () {
      $scope.$emit('updateBrowser');
      $location.url('/account?oauth-completed=box');
      document.location.reload();
    }, function (response) {});
  };

  $scope.openClioAuth = function (e, isUserIntegration) {
    e.stopPropagation();
    e.preventDefault();
    var clioId = window.conf.clio;
    var redirectUri = window.conf.clioUri;
    var state = isUserIntegration ?
      $scope.user.id : $scope.user.currentAccountId
    $window.open(
      "https://app.goclio.com/oauth/authorize?response_type=code&state=" +
      state + "&client_id=" + clioId + "&redirect_uri=" + redirectUri +
      state,
      '_blank',
      'height=700,width=525,status=no,scrollbars=yes, resizable=yes');
  };
  $scope.disconnectClio = function (e, isUserIntegration) {
    e.stopPropagation();
    e.preventDefault();
    Clio[isUserIntegration ? 'userDisconnect' : 'disconnect']({}, function () {
      $scope.$emit('updateBrowser');
      $location.url(
        `/account?oauth-completed=clio${isUserIntegration ? 'user':''}`
      );
      document.location.reload();
    }, function (response) {});
  };

  $scope.update = function () {
    CurrentUser.api.update(null, $scope.user).then(function (data) {
        $scope.user = data;
        $scope.nameValidations = {};
        $scope.nameValidations.success = 'Your profile was updated.';
        $scope.edit = 0;
        $scope.$emit('updateBrowser');
      },
      function (response) {
        $scope.nameValidations = response.data;
      }
    );
  };

  $scope.cancelPassword = function () {
    $scope.change = {};
    $scope.passwordValidations = {};
    $scope.editPassword = 0;
  };
}



// WEBPACK FOOTER //
// ./project/pages/account/account.controller.js